import request from '@/utils/request'

/**
 * 查询积分提现列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAdminIntegralWithdrawal(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.queryAdminIntegralWithdrawal',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核积分提现
 * @param {Object} data 审核数据
 * @returns {Promise} Promise对象
 */
export function auditIntegralWithdrawal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.auditIntegralWithdrawal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}